import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import OpenSource from '../components/OpenSource';
import { PageMetadata } from '../components/PageMetadata';

export default function OpenSourcePage() {
  return <div className="page-content">
    <PageMetadata title="Open Source & Technical Contributions | Elena Nurullina" description="Public repositories, documentation, and technical contributions by Elena Nurullina." />
    <div className="container"><Link to="/" className="back-link"><ArrowLeft size={18} aria-hidden="true" />Back to Home</Link></div>
    <OpenSource />
  </div>;
}
